import { useMutation } from '@apollo/client'
import { useState } from 'react'
import { SEARCH_PAYEES_MUTATION } from '../../graphql/mutation/payees/payees_search.graphql'
import { getGraphQLAPIErrors } from '../../utils/servicesUtils'

export const useSearchService = () => {
  const [errorObj, setErrorObj] = useState(null)
  const [
    loadApi,
    { called = true, loading: gqlLoading = true, data: gqlData = null }
  ] = useMutation(SEARCH_PAYEES_MUTATION, {
    onError: ({ graphQLErrors, networkError }) => {
      getGraphQLAPIErrors({ graphQLErrors, networkError, setErrorObj })
    }
  })

  /**
   * when apollo client updates gqlData, gqlLoading or gqlError
   * trigger subsquent action or data processing.
   * for example: triggering routing change or clean up data
   */
  const searchBillData = gqlData?.billpayPayeeListInquiry?.billerList?.map?.(
    (item, index) => ({
      id: index + 1,
      value: item && item.billerName
    })
  )

  return {
    loadApi,
    called,
    loading: gqlLoading,
    data: gqlData,
    searchBillData,
    error: errorObj
  }
}

export default useSearchService
